import { render, staticRenderFns } from "./WidgetUATJira.vue?vue&type=template&id=3d9c28e0"
import script from "./WidgetUATJira.vue?vue&type=script&lang=js"
export * from "./WidgetUATJira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports